import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { FlowHeader } from "./flow-header";
import { FlowMenu } from "./flow-menu";
import { FlowWorkspace } from "./flow-workspace";

const FlowLayout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);

  const currentUserObj = JSON.parse(localStorage.getItem("currentUser"));
  const menuItems = currentUserObj?.["menus"];
  const location = useLocation();

  useEffect(() => {
    if (!menuItems || menuItems.length === 0 || location.state === null) {
      navigate("/login");
    }
    window.history.replaceState({}, '');
  }, [navigate]);

  const handleDrawerOpen = () => {
    setOpen(open !== true);
  };

  return (
    <Box sx={{ display: "flex", maxHeight: "100vh", overflow: "hidden" }}>
      <FlowHeader open={open} callOnClick={handleDrawerOpen} />
      <Box
        component="main"
        sx={{
          position: "absolute",
          maxHeight: "calc(100vh - 64px)",
          display: "flex",
          flexGrow: 1,
          overflow: "hidden",
          marginTop: "64px",
          pl: 0,
        }}
      >
        {open && (
          <Box
            sx={{
              width: "210px",
              height: "calc(100vh - 64px)",
              borderRight: "1px solid grey",
              overflow: "auto",
              backgroundColor: "#3a8ddd",
              color: "white",
            }}
          >
            <FlowMenu open={open} />
          </Box>
        )}
        <FlowWorkspace open={open} />
      </Box>
    </Box>
  );
};
export default FlowLayout;
